import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../Loader/Loader";
import "./LoginRequiredModal.css";

const LoginRequiredModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  // Reset navigation loader when location changes
  useEffect(() => {
    setIsNavigating(false);
  }, [location.pathname]);

  if (!isOpen) return null;

  const handleLogin = () => {
    onClose();
    navigate("/login");
  };

  const handleCreateAccount = () => {
    setIsNavigating(true);
    onClose();
    navigate("/create-account");
  };

  return (
    <>
      {/* Loader Overlay */}
      {isNavigating && <Loader />}
      
      <div className="login-required-overlay" onClick={onClose}>
        <div className="login-required-modal" onClick={(e) => e.stopPropagation()}>
          <button className="login-required-close" onClick={onClose}>
            ×
          </button>
          <div className="login-required-content">
            <h2>Please Login First</h2>
            <p>You need to be logged in to add items to your cart.</p>
            <div className="login-required-buttons">
              <button className="login-required-btn login-btn" onClick={handleLogin}>
                Login
              </button>
              <button
                className="login-required-btn create-account-btn"
                onClick={handleCreateAccount}
              >
                Create Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginRequiredModal;

